import { useState } from 'react';

const defaults = Object.freeze({
  initialIsOpened: false
});

export default function useToggle(initialIsOn = defaults.initialIsOpened) {

  const [ isOn, setIsOn ] = useState(initialIsOn);

  function toggle() {
    setIsOn( previousIsOn => !previousIsOn);
  }

  function toggleOn() {
    setIsOn(true);
  }

  function toggleOff() {
    setIsOn(false);
  }

  function isToggleOn() {
    return isOn === true;
  }

  function isToggleOff() {
    return isOn === false;
  }

  return {
    isToggleOn,
    isToggleOff,
    toggleOn,
    toggleOff,
    toggle
  }
}
